import { render } from "./App.vue?vue&type=template&id=661d3ae0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=661d3ae0&lang=less"

import exportComponent from "F:\\p_for_tw\\maomeng\\users\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__